var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState, useRef } from 'react';
import { Button, ButtonGroup, DownCaretIcon, Paper, MenuItem, PlusOutlinedIcon, Typography, } from '@kareo/design-system';
import { Grid, Popper, ClickAwayListener, MenuList } from '@material-ui/core';
import styled from 'styled-components';
import rollbar from 'shared-assets/src/errors/errors';
import { getPracticeNoteTypes, getDefaultNoteType, } from 'shared-assets/facesheet-ui/service/facesheet/service';
import { useSnackbar } from 'notistack';
import { NOTE_TYPES_ERROR } from 'shared-assets/facesheet-ui/service/patient/types';
import AlertButton from 'shared-assets/facesheet-ui/components/Facesheet/Error/AlertButton';
var StyledMenuList = styled(MenuList)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    margin: 0;\n    padding: 0;\n  }\n"], ["\n  && {\n    margin: 0;\n    padding: 0;\n  }\n"])));
var CreateNoteButton = function (_a) {
    var patientId = _a.patientId;
    var noteTypesArray = [];
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(noteTypesArray), noteTypes = _c[0], setNoteTypes = _c[1];
    var anchorRef = useRef(null);
    var _d = useState(''), defaultNoteType = _d[0], setDefaultNoteType = _d[1];
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var fetchDefaultNoteType = function () { return __awaiter(void 0, void 0, void 0, function () {
        var defaultNoteTypeResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getDefaultNoteType()];
                case 1:
                    defaultNoteTypeResponse = _a.sent();
                    setDefaultNoteType(defaultNoteTypeResponse.noteTypeName);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchDefaultNoteType().catch(function (error) {
            rollbar.error(error);
        });
        var abortController = new AbortController();
        getPracticeNoteTypes(patientId, abortController.signal)
            .then(function (noteTypes) { return setNoteTypes(noteTypes); })
            .catch(function (error) {
            enqueueSnackbar(NOTE_TYPES_ERROR, {
                variant: 'error',
                action: action,
            });
            rollbar.error(error);
        });
        return function () {
            abortController.abort();
        };
    }, [patientId]);
    var handleCreateNote = function (noteType) {
        setOpen(false);
        var url = "/patients/" + patientId + "/notes/new";
        if (!!noteType) {
            url += "?note_type=" + encodeURIComponent(noteType);
        }
        window.location.href = url;
    };
    var handleToggle = function () {
        setOpen(function (prevOpen) { return !prevOpen; });
    };
    var handleClose = function (event) {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    var action = function () {
        return React.createElement(AlertButton, null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, direction: "column", alignItems: "center" },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(ButtonGroup, { color: "vitality", ref: anchorRef },
                    React.createElement(Button, { size: "small", startIcon: React.createElement(PlusOutlinedIcon, null), onClick: function () { return handleCreateNote(defaultNoteType); }, style: { width: 'max-content' } }, "New Note"),
                    React.createElement(Button, { color: "vitality", size: "small", "aria-controls": open ? 'note-type-list' : undefined, "aria-expanded": open ? 'true' : undefined, "aria-haspopup": "menu", onClick: handleToggle },
                        React.createElement(DownCaretIcon, { fontSize: "xsmall" }))),
                React.createElement(Popper, { open: open, anchorEl: anchorRef.current, placement: "bottom-end" },
                    React.createElement(Paper, { elevation: 3 },
                        React.createElement(ClickAwayListener, { onClickAway: handleClose },
                            React.createElement(StyledMenuList, { id: "note-type-list" }, noteTypes.map(function (noteType) { return (React.createElement(MenuItem, { key: noteType.id, onClick: function () { return handleCreateNote(noteType.title); } },
                                React.createElement(Typography, { component: "div" }, noteType.title))); })))))))));
};
export default CreateNoteButton;
var templateObject_1;
